import type { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<title>Checkout</title>
		<rect
			width={12.5}
			height={11.5}
			x={5.75}
			y={6.75}
			stroke="var(--svg-color, currentColor)"
			strokeWidth={1.5}
			rx={1.25}
		/>
		<path
			fill="var(--svg-color, currentColor)"
			fillRule="evenodd"
			d="M14.5 6H16a4 4 0 0 0-8 0h1.5a2.5 2.5 0 0 1 5 0Z"
			clipRule="evenodd"
		/>
	</svg>
);
export { SvgComponent as Checkout24 };
